import { CreateNewSavedMessageAction } from '../actions/savedMessageComposeModalActions'

type SavedMessageComposeModalState = {
  isOpen: boolean
  id: string
  title: string
  text: string
}

export type SavedMessageComposeModalRootState = {
  savedMessageComposeModal: SavedMessageComposeModalState
}

const initialState: SavedMessageComposeModalState = {
  id: null,
  title: null,
  text: null,
  isOpen: false,
}

const createNewSavedMessage = (
  state = initialState,
  action: CreateNewSavedMessageAction,
) => {
  switch (action.type) {
    case 'OPEN_COMPOSE_MESSAGE_MODAL': {
      const { id, title, text } = action

      return {
        id: id ?? null,
        title: title ?? null,
        text: text ?? null,
        isOpen: true,
      }
    }
    case 'CLOSE_COMPOSE_MESSAGE_MODAL':
      return {
        id: null,
        title: null,
        text: null,
        isOpen: false,
      }
    default:
      return state
  }
}

export default createNewSavedMessage
